import React from 'react';
import { RouterProvider } from 'react-router-dom';

import { appRouter } from '@MP/app/router';
import { useFetchNotice } from '@MP/shared/api/hooks/notice';
import EnvBadge from '@MP/shared/components/EnvBadge';
import { cleanupNoticeInStorage } from '@MP/shared/stores/GlobalUIStore';
import { initializeMinddPlugin } from '@MP/shared/utils/axios.config';

// MinddPlugin 초기화
initializeMinddPlugin();

// 모바일 라우트(`/m`, `/phr`)에서는 테스트 배지를 숨긴다 (mobile.routes.tsx 참고)
const isMobileRoute = (pathname: string) => /^\/m(\/|$)/.test(pathname) || /^\/phr(\/|$)/.test(pathname);

const App = () => {
  const { data: notice } = useFetchNotice();
  const [hideEnvBadge, setHideEnvBadge] = React.useState(() => isMobileRoute(appRouter.state.location.pathname));

  // 공지 배열은 useFetchNotice(React Query)가 소유. 스토어 복제 없이 잔여 localStorage 키만 정리한다.
  React.useEffect(() => {
    if (notice) {
      cleanupNoticeInStorage(notice);
    }
  }, [notice]);

  React.useEffect(
    () => appRouter.subscribe((state) => setHideEnvBadge(isMobileRoute(state.location.pathname))),
    []
  );

  return (
    <>
      {!hideEnvBadge && <EnvBadge />}
      <RouterProvider router={appRouter} />
    </>
  );
};

export default App;
